import { components, useApi } from "@appretio/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateCubeMutation } from "../cubeMutationInvalidation";

type MergeDimInput = components["schemas"]["MergeDimInput"];

export function useMergeDim() {
  const apiClient = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: MergeDimInput) => {
      const response = await apiClient.POST("/v2/forecast/cubes/merge-dim", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in merge dimension response");
      }
      return response.data.result;
    },
    onSuccess: async () => {
      await invalidateCubeMutation(queryClient, { lifecycle: true });
    },
    meta: {
      errorMessage: "Failed to merge dimension"
    }
  });
}
